import React from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className="footer-area-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-5 col-sm-8 col-xs-18">
              <div className="footer-box">
                <Link to="/"><img className="img-responsive" src="/images/logo-footer-2.png" style={{ height: '100px' }} alt="logo" /></Link>
                <div className="footer-about">
                  <p style={{ textAlign: 'justify' }}>ITT COUNCIL, Delhi is Provided Computer (IT) and Technical Courses
                    Thorough Authorised Training Center (ATC) and Self Study Online Center (Online Video Tutorials),
                    Conducted Online Exam of Short Terms Course and Diploma Course after Examination Issue
                    Certificate.<br /></p>
                </div>
                <a href="#" className="join-now-btn mt-0">Our Training Center</a>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
              <div className="footer-box">
                <h3>Featured Links</h3>
                <ul className="featured-links">
                  <li>
                    <ul>
                      <li><Link to='/'>Home</Link></li>
                      <li><Link to='/refund'>Refund &amp; Cancellation Policy</Link></li>
                      <li><Link to='/refund'>Limitation of liabilities</Link></li>
                      <li><Link to='/intellectual'>Intellectual properties</Link></li>
                      <li><Link to='/product'>Product Flow</Link></li>
                      <li><Link to='/atcTerms'>Terms &amp; Condition</Link></li>
                      <li><Link to='/intellectual'>Privacy &amp; Policy</Link></li>
                      <li><Link to='/certificate'>View Certificate</Link></li>
                      <li><Link to='/studentprn'>Student Verification</Link></li>
                    </ul>
                  </li>
                </ul>
                <Link to='https://ittcouncil.blogspot.com' className="join-now-btn" target='_blank'>View Blog</Link>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="footer-box">
                <h3>Information</h3>
                <ul className="corporate-address">
                  <li><i className="fa fa-phone" aria-hidden="true" /><a href="Phone:+91 76 200 200 54">+91 76 200 200 54
                  </a>
                  </li>
                  <li><i className="fa fa-phone" aria-hidden="true" /><a href="Phone:+91 92 843 044 34">+91 92 843 044 34
                  </a>
                  </li>
                  <li><i className="fa fa-envelope-o" aria-hidden="true" /><Link to='mailto:info@ittcouncil.com' target='_blank'>info@ittcouncil.com</Link></li>
                  <li><i className="fa fa-envelope-o" aria-hidden="true" /><Link to='mailto:ittcouncil.delhi@gmail.com' target='_blank'>ittcouncil.delhi@gmail.com</Link></li>
                </ul>
                <ul className="footer-social">
                  <li><Link to='https://www.facebook.com/ittcouncil' target='_blank'><i className="fa fa-facebook" aria-hidden="true" /></Link></li>
                  <li><Link to='https://x.com/ITTCouncil' target='_blank'><i className="fa fa-twitter" aria-hidden="true" /></Link></li>
                  <li><Link to='https://www.linkedin.com/company/ittcouncil' target='_blank'><i className="fa fa-linkedin" aria-hidden="true" /></Link></li>
                  <li><Link to='https://in.pinterest.com/ittcouncil/' target='_blank'><i className="fa fa-pinterest" aria-hidden="true" /></Link></li>
                  <li><Link to='https://plus.google.com/106875198728698241331' target='_blank'><i className="fa fa-google-plus" aria-hidden="true" /></Link></li>
                </ul>
              </div>
              <Link to='https://www.youtube.com/channel/UCAEonaUaC94gUq6vXneAlSg?view_as=subscriber' className="join-now-btn" target='_blank'>Online Study Center</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-area-bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
              <p>© 2024 <Link target="_blank" to="/"> IIT Council</Link> All Rights Reserved. &nbsp; Designed by<Link target="_blank" to="https://www.dualsysco.com/" rel="nofollow"> Dual Sysco</Link> &nbsp; Supported by
                <a target="_blank" href>Solar Online Management System</a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export { Footer };